<div class="layout-auto-1 content md3-surface-fullpadded">
  <!-- Header Area -->
  <div class="grid-auto-1">
    <ng-container *ngIf="!(isLoading && init)">
      <div class="stack-center"
           style="gap: 0.5rem;margin-right: .75rem; align-self: stretch; justify-content: center;padding: 0.75rem">
        <img class="user_avatar__large"
             [src]='app.userData?.idProfilePicture ? app.userData.idProfilePicture : app.defaultProfilePicture'>
        <h3>{{app.userData?.idName}}</h3>
      </div>
      <div>
        <div class="md3-kpi-card">
          <div class="md3-kpi-icon">
            <i class="fad fa-inbox"></i>
          </div>
          <div class="md3-kpi-spawn">
            <div class="md3-kpi-title">{{getRessource('title.taskOverview')}}</div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 0)">
              <em class="highlight">{{homeSummaryData.task.cWIP || 0}}</em>
              <em>{{getRessource('case.cWIP')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 *ngIf="excSecurity.isFeatured('EISUSR')"
                 (click)="openTab($event, 1, 1)">
              <em>{{homeSummaryData.task.cNew || 0}}</em>
              <em>{{getRessource('case.cNew')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 2)">
              <em>{{homeSummaryData.task.cDisp || 0}}</em>
              <em>{{getRessource('task.cDisp')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 3)">
              <em>{{homeSummaryData.task.cReDisp || 0}}</em>
              <em>{{getRessource('task.cReDisp')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 4)">
              <em>{{homeSummaryData.task.cActual || 0}}</em>
              <em>{{getRessource('task.cActual')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 14)">
              <em>{{homeSummaryData.task.cReActual || 0}}</em>
              <em>{{getRessource('task.cReActual')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 1, 5)">
              <em>{{homeSummaryData.task.cFin || 0}}</em>
              <em>{{getRessource('case.cFin')}}</em>
            </div>
            <ng-container *ngIf="excSecurity.isFeatured('EISUSR')">
              <div class="md3-kpi app-cursor-pointer"
                   (click)="openTab($event, 1, 7)">
                <em>{{homeSummaryData.task.cInvoicing || 0}}</em>
                <em>{{getRessource('task.cInvoicing')}}</em>
              </div>
              <div class="md3-kpi app-cursor-pointer"
                   (click)="openTab($event, 1, 11)">
                <em>{{homeSummaryData.task.cOpenQuestion || 0}}</em>
                <em>{{getRessource('task.cOpenQuestion')}}</em>
              </div>
              <div class="md3-kpi app-cursor-pointer"
                   (click)="openTab($event, 1, 999)">
                <em>{{homeSummaryData.task.cEsk || 0}}</em>
                <em>{{getRessource('task.cEsk')}}</em>
              </div>
              <div class="md3-kpi app-cursor-pointer"
                   (click)="openTab($event, 1, 0, true)">
                <em>{{homeSummaryData.task.cSD2Vorgaenge || 0}}</em>
                <em>{{getRessource('task.cSD2Vorgaenge')}}</em>
              </div>
              <!--<div class="md3-kpi app-cursor-pointer"
                   (click)="openTab($event, 1, -1)">
                <em>{{homeSummaryData.task.cDone || 0}}</em>
                <em>{{getRessource('task.cDone')}}</em>
              </div>-->
            </ng-container>
          </div>
        </div>
        <div class="md3-kpi-card">
          <div class="md3-kpi-icon">
            <i class="fad fa-paper-plane"></i>
          </div>
          <div class="md3-kpi-spawn">
            <div class="md3-kpi-title">{{getRessource('title.messageOverview')}}</div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 2, 3)">
              <em>{{homeSummaryData.message.cAll || 0}}</em>
              <em>{{getRessource('message.cAll')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 2, 0)">
              <em>{{homeSummaryData.message.cNew || 0}}</em>
              <em>{{getRessource('message.cNew')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 2, 1)">
              <em>{{homeSummaryData.message.cRead || 0}}</em>
              <em>{{getRessource('message.cRead')}}</em>
            </div>
            <div class="md3-kpi app-cursor-pointer"
                 (click)="openTab($event, 2, 5)">
              <em>{{homeSummaryData.message.cSent || 0}}</em>
              <em>{{getRessource('message.cSent')}}</em>
            </div>
          </div>
        </div>
<!--         <div class="md3-kpi-card" *ngIf="excSecurity.isFeatured('DEVELOPMENT')"> -->
<!--           <div class="md3-kpi-icon"> -->
<!--             <i class="fad fa-message-smile"></i> -->
<!--           </div> -->
<!--           <div class="md3-kpi-spawn"> -->
<!--             <div class="md3-kpi-title">{{getRessource('title.aufgabenOverview')}}</div> -->
<!--             <div class="md3-kpi"> -->
<!--               <em>{{homeSummaryData.aufgabe.cEscalated || 0}}</em> -->
<!--               <em>{{getRessource('aufgabe.cEscalated')}}</em> -->
<!--             </div> -->
<!--             <div class="md3-kpi"> -->
<!--               <em>{{homeSummaryData.aufgabe.cSendEscalated || 0}}</em> -->
<!--               <em>{{getRessource('aufgabe.cSendEscalated')}}</em> -->
<!--             </div> -->
<!--             <div class="md3-kpi"> -->
<!--               <em>{{homeSummaryData.aufgabe.cAll || 0}}</em> -->
<!--               <em>{{getRessource('aufgabe.cAll')}}</em> -->
<!--             </div> -->
<!--           </div> -->
<!--         </div> -->
      </div>
    </ng-container>
  </div>
  <!-- Content Area -->
  <div>
    <ng-container *ngIf="isLoading && init">
      <div class="splash loading">
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!(isLoading && init)">
      <div class="flex-container lh-1-15 app-space-top_1p5">
        <div class="flex-row cols-4">
          <div class="flex-col app-space-bottom_1">
            <!-- To Do Ablaufplanpunkte  List -->
            <div class="md3-masonary-card app-space_none app-space-left_1"
                 style="min-width: 480px" *ngIf="excSecurity.isFeatured('SCHEDULEREAD')">
              <div class="md3-masonary-card__title--wrapper">
                <h2>{{getRessource('title.ablaufplanpunkte')}}</h2>
              </div>
              <app-home-list-ablaufplan [homeSummaryData]="homeSummaryData">
              </app-home-list-ablaufplan>
            </div>
          </div>
          <div class="flex-col flex-col-3  ">
            <div class="content grid-masonry masonry-cols-4  app-space-left_1">
              <!-- Absence Statistics -->
              <div class="md3-masonary-card masonry-width-400"
                   *ngIf="excSecurity.isFeatured('EISUSR')">
                <div class="md3-masonary-card__title--wrapper">
                  <h2>{{getRessource('title.absence')}}</h2>
                </div>
                <exg-data-list [rowSource]="homeSummaryData.absence.data" [displayState]="homeSummaryData.absence.state" style="min-height:200px;max-height:468px">
                  <ng-template #rowTemplate let-row>
                    <div class="list-row list-row-auto-1">
                      <div></div>
                      <div class="typo-small">
                        <span><strong>{{row.Name}}</strong></span>
                        <div class="typo-container-s-s-q">
                          <span>Abwesend von: </span>
                          <span>{{row.absentFrom | excDate}} bis {{row.absentTo | excDate}}</span>
                          <q></q>
                          <span>Keine Disposition von: </span>
                          <span> {{row.noDispoFrom | excDate}} bis {{row.noDispoTo | excDate}}</span>
                          <q></q>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </exg-data-list>
              </div>
              <!-- Widget Statistics -->
              <div class="md3-masonary-card masonry-width-400"
                   *ngIf="excSecurity.isFeatured('EISUSR')">
                <div class="md3-masonary-card__title--wrapper">
                  <h2>{{getRessource('title.caseTyp')}}</h2>
                </div>
                <exg-widget style="margin:auto"
                            *ngIf="!isLoading"
                            [name]="'ExgDbHorizontalBarComponent'"
                            [data]="perparedSummaryData.caseTyp">
                </exg-widget>
              </div>

              <!-- Widget Statistics -->
              <div class="md3-masonary-card masonry-width-400"
                   *ngIf="excSecurity.isFeatured('EISUSR')">
                <div class="md3-masonary-card__title--wrapper">
                  <h2>{{getRessource('title.case')}}</h2>
                </div>
                <exg-widget style="margin:auto"
                            *ngIf="!isLoading"
                            [name]="'ExgDbVerticalbarComponent'"
                            [data]="perparedSummaryData.case">
                </exg-widget>
              </div>

              <!-- Widget Statistics -->
              <div class="md3-masonary-card masonry-width-400">
                <div class="md3-masonary-card__title--wrapper">
                  <h2>{{getRessource('title.taskTyp')}}</h2>
                </div>
                <exg-widget style="margin:auto"
                            *ngIf="!isLoading"
                            [name]="'ExgDbHorizontalBarComponent'"
                            [data]="perparedSummaryData.taskTyp">
                </exg-widget>
              </div>

              <!-- Widget Statistics -->
              <div class="md3-masonary-card masonry-width-400">
                <div class="md3-masonary-card__title--wrapper">
                  <h2>{{getRessource('title.task')}}</h2>
                </div>
                <exg-widget style="margin:auto"
                            *ngIf="!isLoading"
                            [name]="'ExgDbVerticalbarComponent'"
                            [data]="perparedSummaryData.task">
                </exg-widget>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- Widget Statistics -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>{{getRessource('title.message')}}</h2> -->
<!-- 					</div> -->
<!-- 					<exg-widget style="margin:auto" -->
<!-- 					            [name]="'ExgDbHorizontalBarComponent'" -->
<!-- 					            [data]="perparedSummaryData.message"> -->
<!-- 					</exg-widget> -->
<!-- 				</div> -->

<!-- Widget Statistics -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>{{getRessource('title.aufgabe')}}</h2> -->
<!-- 					</div> -->
<!-- 					<exg-widget style="margin:auto" -->
<!-- 					            [name]="'ExgDbHorizontalBarComponent'" -->
<!-- 					            [data]="perparedSummaryData.aufgabe"> -->
<!-- 					</exg-widget> -->
<!-- 				</div> -->

<!-- 				&lt;!&ndash; Current Task List &ndash;&gt; -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>Aktuelle Tasks</h2> -->
<!-- 						<i class="far fa-arrow-right" (click)="clickAction()"></i> -->
<!-- 					</div> -->
<!-- 					&lt;!&ndash; Row Change Event &ndash;&gt; -->
<!-- 					<exg-data-list #currentTasksList -->
<!-- 					               [allowMultiSelection]="false" -->
<!-- 					               [allowSingleSelection]="true" -->
<!-- 					               [rowSource]="currentTasks" -->
<!-- 					               selectKey="tskID" -->
<!-- 					               [displayState]="currentTasksState" -->
<!-- 					               (RowDblClick)="clickAction($event, currentTasks)" -->
<!-- 					               class="content" style="height: 18rem"> -->
<!-- 						<ng-template #rowTemplate let-row> -->
<!-- 							<div class="list-row list-two-line"> -->
<!-- 								<span class="list-primary-text">{{row.cnfName}} - #{{row.tskIdent}}</span> -->
<!-- 								<span -->
<!-- 									class="list-metadata">{{row.tskPlanDate | date: 'dd.MM.yyyy'}}</span> -->
<!-- 							</div> -->
<!-- 						</ng-template> -->
<!-- 					</exg-data-list> -->
<!-- 				</div> -->

<!-- 				&lt;!&ndash; Deadline collapse List &ndash;&gt; -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>Fristen</h2> -->
<!-- 					</div> -->
<!-- 					<div class="content" style="height: 18rem"> -->
<!-- 						<div class="expanels"> -->
<!-- 							<div class="expanel"> -->
<!-- 								<input type="checkbox" [id]="1"> -->
<!-- 								<label class="expanel-label" -->
<!-- 								       [for]="1">{{'Auslaufende Tasks' + ' (' + expiringTasks.length + ')'}}</label> -->
<!-- 								<div class="expanel-content"> -->
<!-- 									<ng-container *ngFor="let task of expiringTasks; let i = index"> -->
<!-- 										<div class="list-row list-single-line list-row-1-auto" -->
<!-- 										     (dblclick)="clickAction()"> -->
<!-- 	                      <span class="list-primary-text">{{task.cnfName}} -->
<!-- 		                      - #{{task.tskIdent}}</span> -->
<!-- 											<span class="list-metadata">{{task.tskPlanDate | date: 'dd.MM.yyyy'}}</span> -->
<!-- 										</div> -->
<!-- 									</ng-container> -->
<!-- 								</div> -->
<!-- 							</div> -->
<!-- 							<div class="expanel"> -->
<!-- 								<input type="checkbox" [id]="2"> -->
<!-- 								<label class="expanel-label" -->
<!-- 								       [for]="2">{{'Tasks in Nachreichung' + ' (' + handOverTasks.length + ')'}}</label> -->
<!-- 								<div class="expanel-content"> -->
<!-- 									<ng-container *ngFor="let task of handOverTasks; let i = index"> -->
<!-- 										<div class="list-row list-single-line list-row-1-auto" -->
<!-- 										     (dblclick)="clickAction()"> -->
<!-- 	                      <span class="list-primary-text">{{task.cnfName}} -->
<!-- 		                      - #{{task.tskIdent}}</span> -->
<!-- 											<span class="list-metadata">{{task.tskPlanDate | date: 'dd.MM.yyyy'}}</span> -->
<!-- 										</div> -->
<!-- 									</ng-container> -->
<!-- 								</div> -->
<!-- 							</div> -->
<!-- 							<div class="expanel"> -->
<!-- 								<input type="checkbox" [id]="3"> -->
<!-- 								<label class="expanel-label" -->
<!-- 								       [for]="3">{{'Maßnahmen' + ' (' + consolidatedMeasures.length + ')'}}</label> -->
<!-- 								<div class="expanel-content"> -->
<!-- 									<ng-container *ngFor="let measure of consolidatedMeasures; let i = index"> -->
<!-- 										<div class="list-row list-two-line list-row-1-auto" -->
<!-- 										     (dblclick)="clickAction()"> -->
<!-- 	                    <span> -->
<!-- 	                      <span class="list-primary-text"> {{measure.cnfName}} #{{measure.tskIdent}}</span> -->
<!-- 	                      <span class="list-secondary-text">{{measure.actionText}}</span> -->
<!-- 	                    </span> -->
<!-- 											<span class="list-metadata">{{measure.deadline | date: 'dd.MM.yyyy'}}</span> -->
<!-- 										</div> -->
<!-- 									</ng-container> -->
<!-- 								</div> -->
<!-- 							</div> -->
<!-- 						</div> -->
<!-- 					</div> -->
<!-- 				</div> -->

<!-- 				&lt;!&ndash; Assigned Action List &ndash;&gt; -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>Meine Aufgaben</h2> -->
<!-- 						<i class="far fa-edit" (click)="clickAction()"></i> -->
<!-- 					</div> -->
<!-- 					&lt;!&ndash; Row Change Event &ndash;&gt; -->
<!-- 					<exg-data-list #assignedActionsList -->
<!-- 					               [allowMultiSelection]="false" -->
<!-- 					               [allowSingleSelection]="true" -->
<!-- 					               [rowSource]="assignedActionsData" -->
<!-- 					               selectKey="actID" -->
<!-- 					               (RowDblClick)="clickAction($event, assignedActionsData)" -->
<!-- 					               [displayState]="assignedActionsState" -->
<!-- 					               class="content" style="height: 18rem"> -->
<!-- 						<ng-template #rowTemplate let-row> -->
<!-- 							<div class="list-row list-two-line list-row-1-auto"> -->
<!--                 <span class="list-primary-text"> -->
<!-- &lt;!&ndash; 	                {{getStatusLabel(row.actStatus)}}{{getPercentDone(row.actPercentDone)}} &ndash;&gt; -->
<!--                 </span> -->
<!--                 <span class="list-secondary-text"> -->
<!-- 	                {{row.actSubject}} -->
<!--                 </span> -->
<!-- 								<span class="list-metadata"> -->
<!-- 									{{row.actDueTo | date: 'dd.MM.yyyy'}} -->
<!-- 								</span> -->
<!-- 							</div> -->
<!-- 						</ng-template> -->
<!-- 					</exg-data-list> -->
<!-- 					<div class="md3-masonary-card__footer&#45;&#45;wrapper" style="cursor: pointer" -->
<!-- 					     (click)="clickAction()"> -->
<!-- 						<i class="fas fa-plus"></i> -->
<!-- 						<span>Aufgabe hinzufügen</span> -->
<!-- 					</div> -->
<!-- 				</div> -->

<!-- 				&lt;!&ndash; Created Action List &ndash;&gt; -->
<!-- 				<div class="md3-masonary-card"> -->
<!-- 					<div class="md3-masonary-card__title&#45;&#45;wrapper"> -->
<!-- 						<h2>Überwachen</h2> -->
<!-- 						<i class="far fa-edit" (click)="clickAction()"></i> -->
<!-- 					</div> -->
<!-- 					&lt;!&ndash; Row Change Event &ndash;&gt; -->
<!-- 					<exg-data-list #createdActionsList -->
<!-- 					               [allowMultiSelection]="false" -->
<!-- 					               [allowSingleSelection]="true" -->
<!-- 					               [rowSource]="createdActionsData" -->
<!-- 					               selectKey="actID" -->
<!-- 					               (RowDblClick)="clickAction()" -->
<!-- 					               [displayState]="createdActionsState" -->
<!-- 					               class="content" style="height: 18rem"> -->
<!-- 						<ng-template #rowTemplate let-row> -->
<!-- 							<div class="list-row list-two-line"> -->
<!-- 								<div class="grid"> -->
<!-- 	                <span class="list-primary-text"> -->
<!-- &lt;!&ndash; 		                {{getStatusLabel(row.actStatus)}} &ndash;&gt; -->
<!-- &lt;!&ndash; 		                {{getPercentDone(row.actPercentDone)}} &ndash;&gt; -->
<!-- &lt;!&ndash; 		                - {{row.usrFullname}} &ndash;&gt; -->
<!-- 	                </span> -->
<!-- 									<span -->
<!-- 										class="list-secondary-text">{{row.actSubject}}</span> -->
<!-- 								</div> -->
<!-- 							</div> -->
<!-- 						</ng-template> -->
<!-- 					</exg-data-list> -->
<!-- 					<div class="md3-masonary-card__footer&#45;&#45;wrapper" style="cursor: pointer" -->
<!-- 					     (click)="clickAction()"> -->
<!-- 						<i class="fas fa-plus"></i> -->
<!-- 						<span>Aufgabe hinzufügen</span> -->
<!-- 					</div> -->
<!-- 				</div> -->
